<template>
  <div class="header">
    <div class="top">
      <img class="logo"
           src="@/assets/images/logo.png" />
      <img class="navs"
           @click="show=!show"
           src="@/assets/images/rem/nav.png" />
    </div>
    <van-popup v-model="show"
               position="top"
               :style="{ top: '1rem' }">
      <ul class="navsUl">
        <li @click="navulClick(item.id)"
            v-for="item in link"
            :key='item.url'>
          <router-link v-if="item.id==1||item.id==5"
                       :to='item.url'><span>{{item.text}}</span><img src="@/assets/images/rem/rightjt.png" /></router-link>
          <a v-else-if="item.id!=4"
             target="_blank"
             :href='item.url'><span>{{item.text}}</span><img src="@/assets/images/rem/rightjt.png" /></a>
          <a v-else><span>{{item.text}}</span><img src="@/assets/images/rem/rightjt.png" /></a>
        </li>
      </ul>
    </van-popup>
    <div class="gotop"
         v-show="flag_scroll">
      <img @click="goTop"
           src="@/assets/images/rem/top.png" />
    </div>
    <van-dialog v-model="dshow"
                title="温馨提示"
                :show-confirm-button="false"
                show-cancel-button>
      <p class="dshow">商家入驻请在PC端操作<br>
        链接：www.9buqi.com</p>
    </van-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { Popup } from 'vant';
import $ from 'jquery'
import { Dialog } from 'vant';
Vue.use(Popup);
Vue.use(Dialog);
export default {
  name: 'headers',
  data () {
    return {
      link: [
        {
          id: 1,
          url: '/Page/Indexrem',
          text: '首页'
        },
       /*  {
          id: 2,
          url: 'https://h5.xinfushenghuo.cn/',
          text: '商城'
        }, */
        // {
        //     id:3,
        //     url:'https://old.9buqi.com',
        //     text:'九不欺活米'
        // },
        {
          id: 4,
          url: 'http://shop.9buqi.com/home/Showjoinin/index.html',
          text: '登录/入驻'
        },
        {
          id: 5,
          url: '/Page/aboutrem',
          text: '关于我们'
        }
      ],
      path: '/Page/Indexrem',
      show: false,
      flag_scroll: false,
      dshow: false
    }
  },
  created () {
    //  console.log(this.login)
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  computed: {

  },
  methods: {
    navulClick (id) {
      this.show = false;
      if (id == 4) {
        this.dshow = true;
      }
    },
    handleScroll (env) {
      var scroll_top = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scroll_top = document.documentElement.scrollTop;
      }
      else if (document.body) {
        scroll_top = document.body.scrollTop;
      }
      if (scroll_top > 300) {
        this.flag_scroll = true
      } else {
        this.flag_scroll = false
      }
    },
    goTop () {
      $("html,body").animate({
        scrollTop: 0,
        screenLeft: 0,
      }, 400);
    }
  },
  watch: {
    '$route': {//深度监听，可监听到对象、数组的变化
      handler (val, oldVal) {
        this.path = val.path;
      },
      deep: true //true 深度监听
    }
  }
}
</script>
<style lang="less" scoped>
.dshow {
  font-size: 0.3rem;
  color: #333333;
  text-align: center;
  padding: 0.49rem 0 0.36rem 0;
}
.header {
  max-width: 7.5rem;
  width: 100%;
  .top {
    height: 1rem;
    position: fixed;
    z-index: 3000;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    display: flex;
    padding: 0 0.3rem;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 2.19rem;
    }
    .navs {
      width: 0.5rem;
    }
  }
  .navsUl {
    li {
      padding: 0 0.1rem 0 0.29rem;
      box-sizing: border-box;
      border-bottom: 1px solid #eaeaea;
      a {
        display: flex;
        justify-content: space-between;
        height: 1.2rem;
        align-items: center;
        font-size: 0.32rem;
        color: #333333;
        img {
          width: 0.56rem;
        }
      }
      &:last-child {
        border: none;
      }
    }
  }
  .gotop {
    position: fixed;
    right: 2%;
    z-index: 100;
    overflow: hidden;
    border-radius: 50%;
    width: 0.9rem;
    height: 0.9rem;
    bottom: 1rem;
    box-shadow: 0px 1px 5px 1px rgba(102, 102, 102, 0.6);
    img {
      background-size: 100% 100%;
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/headerrem.vue